<template>
    <b-modal
            body-class="p-0"
            cancel-disabled
            hide-footer
            id="max-devices-in-basket-modal"
            title="">
        <div class="modal-body modal-body-lg pt-0">
            <div>
                <animated-info class="mx-auto mb-4"></animated-info>
            </div>
            <h4 class="text-center mb-4">Your device is in warranty, but you already have other devices in your basket</h4>
            <p class="text-center mb-4">
                We cannot repair an in-warranty device as part of a larger repair order. Either remove any existing devices from your basket, or complete the order and then book this device as part of a separate order.
            </p>
            <p class="text-center">
                <button @click="goToBasket()" class="btn btn-primary btn-lg" :disabled="deleting"><i class="fa fa-pulse fa-spinner" v-if="deleting"></i> Go to basket</button>
            </p>
            <p class="text-center">
				<button class="btn btn-link" @click="closeModal()">Close</button>
            </p>
        </div>
    </b-modal>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: 'MaxDevicesInBasketModal',

        data() {
            return {
                deleting: false
            }
        },

        computed: {
            ...mapGetters(['currentDeviceId'])
        },

        methods: {
            ...mapActions(['deleteDevice']),

			closeModal() {
				this.$bvModal.hide('max-devices-in-basket-modal')
			},

            goToBasket() {
                this.deleting = true;
                this.deleteDevice(this.currentDeviceId).then(() => {
                    this.deleting = false;
                    this.$router.push({name: 'basket'});
                });
            }
        }
    }
</script>

<style scoped>

</style>